import React, {useState, useEffect, useContext, useCallback} from 'react';
import {APIGetProjectById, APIGetProjectDraftsById} from "#src/api/projects/projects";
import {useParams} from 'react-router';

export const HFProjectsDetails = () => {

	const [project, setProject] = useState(null);
	const [drafts, setDrafts] = useState(null);
	let {id} = useParams();

	useEffect(() => {

		if(typeof id !== "undefined" && id !== null) {
			APIGetProjectById(id).then((data) => {
				console.log(data);
				setProject(data);
			});

			APIGetProjectDraftsById(id).then((data) => {
				setDrafts(data);
			});

		}

	}, [id]);



	console.log("--------------");
	console.log(id);
	console.log(project);
	console.log(drafts);

}
